const CADCARGO = () => import('../views/CadCargos.vue')
const CADPERGF = () => import('../views/PerguntasFrequentes')
const CADFESP = () => import('../views/FuncoesEspecificas')
const TERCER = () => import('../views/Tercerizados')
const ESTAG = () => import('../views/Estagiarios')

export default [
  { name: 'viewCadCargos', path: '/cadastros/cad-cargos', component: CADCARGO, meta: { acl: true } },
  { name: 'viewCadPreguntas', path: '/cadastros/perguntas-frequentes', component: CADPERGF, meta: { acl: true } },
  { name: 'viewCadFuncoes', path: '/cadastros/funcoes-especificas', component: CADFESP, meta: { acl: true } },
  { name: 'viewTercer', path: '/cadastros/tercerizados', component: TERCER, meta: { acl: true } },
  { name: 'viewEstag', path: '/cadastros/estagiarios', component: ESTAG, meta: { acl: true } }
]
